import { render, staticRenderFns } from "./Slider.vue?vue&type=template&id=10e5488f&scoped=true&lang=pug"
import script from "./Slider.vue?vue&type=script&lang=js"
export * from "./Slider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e5488f",
  null
  
)

export default component.exports